import Emitter from 'gleam-shared/helpers/emitter'
import { isString, isFunction } from 'gleam-shared/helpers/nodash'

export default function BasePreview({ destroy, description, ...extra } = {}) {
  if (!isFunction(destroy)) {
    throw new Error('a destroy function should be given!')
  }

  if (!isString(description)) {
    throw new Error('a description string should be given!')
  }

  const loadEmitter = Emitter()
  const errorEmitter = Emitter()

  return {
    destroy,
    description,
    loadEmitter,
    errorEmitter,
    ...extra
  }
}
